var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSchool({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9pse19gmna)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.343 11H0a5.006 5.006 0 0 1 5-5h6V1.636A1.638 1.638 0 0 1 13.33.154l3.2 1.5a1 1 0 0 1 0 1.7L13 5v1h6a5.006 5.006 0 0 1 5 5h-4.343a3 3 0 0 1-2.092-.85l-2.736-2.978a4.074 4.074 0 0 0-5.687.03L6.464 10.12A3.017 3.017 0 0 1 4.343 11zM12 19a1 1 0 0 0-1 1v4h2v-4a1 1 0 0 0-1-1zm7.657-6H24v8a3 3 0 0 1-3 3h-6v-4a3 3 0 0 0-6 0v4H3a3 3 0 0 1-3-3v-8h4.343a4.992 4.992 0 0 0 3.565-1.495l2.678-2.92a2.07 2.07 0 0 1 2.8-.03l2.738 2.98A4.968 4.968 0 0 0 19.657 13zM6 21a1 1 0 0 0-1-1H4a1 1 0 0 0 0 2h1a1 1 0 0 0 1-1zm0-4a1 1 0 0 0-1-1H4a1 1 0 0 0 0 2h1a1 1 0 0 0 1-1zm8-4a2 2 0 1 0-4 0 2 2 0 0 0 4 0zm7 8a1 1 0 0 0-1-1h-1a1 1 0 0 0 0 2h1a1 1 0 0 0 1-1zm-1-5h-1a1 1 0 0 0 0 2h1a1 1 0 1 0 0-2z",
    fill: "#5E6175"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "9pse19gmna"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchool);
export default __webpack_public_path__ + "static/media/school.237206cd8dd763eeab5e508f26ae0bd1.svg";
export { ForwardRef as ReactComponent };